import { Reducer } from 'interfaces'
import { PublicDashboardAppState } from 'interfaces/publicDashboard'
import { SET_PUBLIC_FILTER } from 'actions/publicDashboardActions'

const INIT_STATE: PublicDashboardAppState = {
  category: 'all',
  location: 'all',
  incomeRange: 'all',
  timeframe: '6-months',
}
export const publicDashboardAppReducer: Reducer<PublicDashboardAppState> = (prevState = INIT_STATE, action) => {
  if (action.type === SET_PUBLIC_FILTER) {
    return {
      ...prevState,
      ...action.payload,
    }
  }

  return prevState
}
